import { ReactComponent as WalterLearning } from '../assets/WalterLearning.svg'
import { ReactComponent as WalterSanteColor } from '../assets/WalterSanteColor.svg'
import { tunnelBrand, tunnelSiteUrl } from '../utils/tunnelBrand'

/** Logo du tunnel, cliquable vers le site de la marque : Edumiam sur inscription.edumiam.com, sinon Walter. */
const TunnelLogo = ({ isSante }: { isSante: boolean }) => {
  const edumiam = tunnelBrand()
  const open = () => window.open(tunnelSiteUrl(isSante), '_self')
  if (edumiam) {
    return (
      <edumiam.LogoComponent width={180} height={48} style={{ display: 'block', overflow: 'visible' }} onClick={open} />
    )
  }
  return isSante ? <WalterSanteColor width="162px" onClick={open} /> : <WalterLearning width="180px" onClick={open} />
}

export default TunnelLogo
